import(/* webpackMode: "eager" */ "/vercel/path0/app/scholarships/page.tsx");
